/** @format */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { toast } from "react-toastify";
import { locationServices, airfreightratesServices } from "../../../Services";

export const AddAirFreightRate = () => {
  const [countryList, setCountryList] = useState([]);
  const [destinationCountryValue, setDestinationCountryValue] = useState("");
  const [originCountryValue, setOriginCountryValue] = useState("");
  const [originCityValue, setOriginCityValue] = useState("");
  const [destinationCityValue, setDestinationCityValue] = useState("");
  const [originCityList, setOriginCityList] = useState([]);
  const [destinationCityList, setDestinationCityList] = useState([]);
  const [loader, setLoader] = useState(true);

  const history = useHistory();
  const formik = useFormik({
    initialValues: {
      origin_country_id: "",
      destination_country_id: "",
      origin_city_id: "",
      destination_city_id: "",
      minimum_amount: "",
      normal_amount: "",
      amount_greater_than_45: "",
      amount_greater_than_100: "",
      amount_greater_than_250: "",
      amount_greater_than_500: "",
      amount_greater_than_1000: "",
      fuel: "",
      port_delivery_tt: "",
      door_delivery_tt: "",
    },
    validationSchema: Yup.object({
      origin_country_id: Yup.string().required("Required"),
      destination_country_id: Yup.string().required("Required"),
      origin_city_id: Yup.string().required("Required"),
      destination_city_id: Yup.string().required("Required"),
      minimum_amount: Yup.string().required("Required"),
      normal_amount: Yup.string().required("Required"),
      amount_greater_than_45: Yup.string().required("Required"),
      amount_greater_than_100: Yup.string().required("Required"),
      amount_greater_than_250: Yup.string().required("Required"),
      amount_greater_than_500: Yup.string().required("Required"),
      amount_greater_than_1000: Yup.string().required("Required"),
      fuel: Yup.string().required("Required"),
      port_delivery_tt: Yup.string().required("Required"),
      door_delivery_tt: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      setLoader(true);
      let postData = {
        ...values,
      };
      airfreightratesServices.addAirfreightrates(postData).then((res) => {
        if (res.status) {
          setLoader(false);
          history.push("/air-freight-rate-list");
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      });
    },
  });

  useEffect(() => {
    getCountryList();
  }, []);

  const getCityList = (id, act) => {
    let param = {
      page: 1,
      limit: 300,
      country_id: id.value,
    };
    locationServices.getCity(param).then((res) => {
      if (res.status) {
        let arry = [];
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.city_name, data: list });
        });
        switch (act) {
          case "destination":
            setDestinationCityList(arry);
            setDestinationCityValue("");
            break;
          case "origin":
            setOriginCityList(arry);
            let activeCity = arry.filter(
              (item) => item.data.city_name === "Dubai"
            );
            if (activeCity.length) {
              setOriginCityValue(activeCity[0]);
              formik.setValues({
                ...formik.values,
                origin_country_id: id.value,
                origin_city_id: activeCity[0].value,
              });
            } else {
              formik.setValues({
                ...formik.values,
                origin_country_id: id.value,
                origin_city_id: "",
              });
              setOriginCityValue("");
            }
            break;
        }
        setLoader(false);
      }
    });
  };

  const getCountryList = () => {
    let param = { page: 1, limit: 300 };

    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        let arry = [];
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.country_name, data: list });
        });

        let activeCountry = arry.filter(
          (item) => item.data.country_currency === "AED"
        );
        if (activeCountry.length) {
          onSelectCountry(activeCountry[0], "origin");
        }

        setCountryList(arry);
      } else {
        toast.error(res.message);
      }
    });
  };

  const onSelectCountry = (e, act) => {
    switch (act) {
      case "origin":
        getCityList(e, act);
        setOriginCountryValue(e);

        break;
      case "destination":
        getCityList(e, act);
        setDestinationCountryValue(e);
        formik.setValues({
          ...formik.values,
          destination_country_id: e.value,
          destination_city_id: "",
        });

        break;
    }
  };

  const onSelectCity = (e, act) => {
    let arry1 = originCityList;
    let arry2 = destinationCityList;
    let newArry1 = [];
    let newArry2 = [];
    arry1.map((list) => {
      newArry1.push({ ...list, isdisabled: list.value === e.value });
    });
    arry2.map((list) => {
      newArry2.push({ ...list, isdisabled: list.value === e.value });
    });
    setOriginCityList(newArry1);
    setDestinationCityList(newArry2);
    switch (act) {
      case "origin":
        setOriginCityValue(e);
        formik.setValues({ ...formik.values, origin_city_id: e.value });

        break;
      case "destination":
        setDestinationCityValue(e);
        formik.setValues({ ...formik.values, destination_city_id: e.value });

        break;
    }
  };

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              <div className="row">
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Origin country </label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.origin_country_id
                            ? !formik.errors.origin_country_id
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={originCountryValue}
                      onChange={(e) => onSelectCountry(e, "origin")}
                      options={countryList}
                    />
                    {formik.touched.origin_country_id &&
                    formik.errors.origin_country_id ? (
                      <div className="text-danger">
                        {formik.errors.origin_country_id}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Origin city</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.origin_city_id
                            ? !formik.errors.origin_city_id
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={originCityValue}
                      // isOptionDisabled={(option) => option.isdisabled}
                      onChange={(e) => onSelectCity(e, "origin")}
                      options={originCityList}
                    />
                    {formik.touched.origin_city_id &&
                    formik.errors.origin_city_id ? (
                      <div className="text-danger">
                        {formik.errors.origin_city_id}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Destination country</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.destination_country_id
                            ? !formik.errors.destination_country_id
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={destinationCountryValue}
                      onChange={(e) => onSelectCountry(e, "destination")}
                      options={countryList}
                    />
                    {formik.touched.destination_country_id &&
                    formik.errors.destination_country_id ? (
                      <div className="text-danger">
                        {formik.errors.destination_country_id}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Destination city</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.destination_city_id
                            ? !formik.errors.destination_city_id
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={destinationCityValue}
                      // isOptionDisabled={(option) => option.isdisabled}
                      onChange={(e) => onSelectCity(e, "destination")}
                      options={destinationCityList}
                    />
                    {formik.touched.destination_city_id &&
                    formik.errors.destination_city_id ? (
                      <div className="text-danger">
                        {formik.errors.destination_city_id}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Minimum CBM</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.minimum_amount
                          ? !formik.errors.minimum_amount
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("minimum_amount")}
                      placeholder="Enter minimum amount"
                    />
                    {formik.touched.minimum_amount &&
                    formik.errors.minimum_amount ? (
                      <div className="text-danger">
                        {formik.errors.minimum_amount}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Normal amount</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.normal_amount
                          ? !formik.errors.normal_amount
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("normal_amount")}
                      placeholder="Enter normal amount"
                    />
                    {formik.touched.normal_amount &&
                    formik.errors.normal_amount ? (
                      <div className="text-danger">
                        {formik.errors.normal_amount}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">+ 45 Kg</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.amount_greater_than_45
                          ? !formik.errors.amount_greater_than_45
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("amount_greater_than_45")}
                      placeholder="Enter Amount"
                    />
                    {formik.touched.amount_greater_than_45 &&
                    formik.errors.amount_greater_than_45 ? (
                      <div className="text-danger">
                        {formik.errors.amount_greater_than_45}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">+ 100 Kg</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.amount_greater_than_100
                          ? !formik.errors.amount_greater_than_100
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("amount_greater_than_100")}
                      placeholder="Enter Amount"
                    />
                    {formik.touched.amount_greater_than_100 &&
                    formik.errors.amount_greater_than_100 ? (
                      <div className="text-danger">
                        {formik.errors.amount_greater_than_100}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">+ 250 Kg</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.amount_greater_than_250
                          ? !formik.errors.amount_greater_than_250
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("amount_greater_than_250")}
                      placeholder="Enter Amount"
                    />
                    {formik.touched.amount_greater_than_250 &&
                    formik.errors.amount_greater_than_250 ? (
                      <div className="text-danger">
                        {formik.errors.amount_greater_than_250}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">+ 500 Kg</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.amount_greater_than_500
                          ? !formik.errors.amount_greater_than_500
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("amount_greater_than_500")}
                      placeholder="Enter Amount"
                    />
                    {formik.touched.amount_greater_than_500 &&
                    formik.errors.amount_greater_than_500 ? (
                      <div className="text-danger">
                        {formik.errors.amount_greater_than_500}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">+ 1000 Kg</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.amount_greater_than_1000
                          ? !formik.errors.amount_greater_than_1000
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("amount_greater_than_1000")}
                      placeholder="Enter Amount"
                    />
                    {formik.touched.amount_greater_than_1000 &&
                    formik.errors.amount_greater_than_1000 ? (
                      <div className="text-danger">
                        {formik.errors.amount_greater_than_1000}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Fuel</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.fuel
                          ? !formik.errors.fuel
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("fuel")}
                      placeholder="Enter Fuel"
                    />
                    {formik.touched.fuel && formik.errors.fuel ? (
                      <div className="text-danger">{formik.errors.fuel}</div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Port delivery tt</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.port_delivery_tt
                          ? !formik.errors.port_delivery_tt
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("port_delivery_tt")}
                      placeholder="Enter port delivery tt"
                    />
                    {formik.touched.port_delivery_tt &&
                    formik.errors.port_delivery_tt ? (
                      <div className="text-danger">
                        {formik.errors.port_delivery_tt}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Door delivery tt</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.door_delivery_tt
                          ? !formik.errors.door_delivery_tt
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("door_delivery_tt")}
                      placeholder="Enter door delivery tt"
                    />
                    {formik.touched.door_delivery_tt &&
                    formik.errors.door_delivery_tt ? (
                      <div className="text-danger">
                        {formik.errors.door_delivery_tt}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
